/**
 * Cleans text for use in metadata by removing soft hyphens (&shy;) and HTML tags
 * @param text - The text to clean
 * @returns Cleaned text suitable for metadata
 */
export const cleanMetadataText = (text: string): string => {
  return text.replaceAll("&shy;", "").replace(/<[^>]*>/g, "");
};

export const truncateTextForPreview = (
  text: string,
  maxLength: number,
): string => {
  const plain = cleanMetadataText(text);
  if (plain.length <= maxLength) {
    return text;
  }
  return `${plain.slice(0, maxLength)}...`;
};
